// types
import type { ThemeNameProps } from 'themes/theme.types';

export function getContentBoxColor({
  color,
  themeName,
}: {
  color: SliderTextColors;
  themeName: ThemeNameProps;
}): SliderTextColors {
  const themesWithInvertedContentBoxColor: ThemeNameProps[] = [
    'NORD',
    'KOLO',
    'TWYFORD',
    'DEFAULT',
    'GDDS',
  ];

  if (!themesWithInvertedContentBoxColor.includes(themeName)) return color;

  const _color = color === 'white' ? 'black' : 'white';

  return _color;
}
